module.exports = __webpack_public_path__ + "media/images/project/add-section-882dd81c78231d1d24a7f2a3fd5ec383.svg";